"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icon = {
    defaultProps: {
        boxSize: '16px',
        lineHeight: '16px',
    },
};
exports.default = Icon;
